var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card mb-hide" }, [
      _c("h1", { staticClass: "title text-center" }, [
        _c("img", {
          attrs: { src: "/static/Wirecard_Logo_250w.png", alt: "wirecard" }
        })
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("div", [
          _vm._v("Moip pagamentos e Wirecard Brasil S/A são a mesma empresa?")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Sim, a Wirecard adquiriu o Moip em 2016, então trata-se da mesma empresa, porém agora estamos assumindo o posicionamento global da companhia como Wirecard."
          )
        ])
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("div", [_vm._v("O que é o Wirecard?")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      A Wirecard iniciou suas operações no mercado europeu em 1999, e está no Brasil desde 2017. No ano de 2018 ultrapassamos o valor de €20 bilhões na Bolsa de Frankfurt, a maior da Alemanha, e nos tornamos uma das 30 maiores empresas de capital público do país.\n      "
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://wirecard.com.br/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("Saiba mais sobre o Wirecard")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("div", [_vm._v("É seguro pagar pelo Wirecard?")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Sim, possuímos o Selo PCI Compliance, que é concedido somente a empresas que seguem normas e padrões de segurança internacionais para transações financeiras.\n      "
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://wirecard.com.br/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("Saiba mais sobre a segurança do Wirecard.")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eb096b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb096b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Wirecard.vue
// module id = null
// module chunks = 